import type { BeforeSendEvent } from '@vercel/analytics/next';

/**
 * Ad landing pages, dropped from Vercel Web Analytics: GA4 and PostHog already
 * report this traffic for campaign attribution, so the Vercel copy is
 * duplication we pay MIUs for. These paths were ~46% of all billed Web
 * Analytics events when measured for FFH-1971 (Aug 2026).
 */
const ADS_LANDING_PATHS = [
  '/ai-team-rating',
  '/ai-team-rating-v2',
  '/ai-team-rating-v3'
];

/**
 * Fraction of page views Speed Insights measures, not of individual vitals: its
 * script decides once per page load, before any vital is collected. Core Web
 * Vitals stabilise on far fewer samples than our traffic provides, so this
 * trades redundant precision for MIUs.
 */
export const SPEED_INSIGHTS_SAMPLE_RATE = 0.05;

/**
 * Web Analytics `beforeSend`: returning null drops an event before it is billed.
 *
 * Vercel's injected script passes an absolute URL today, but it is a remote
 * script versioned independently of the npm package, so a base is supplied to
 * keep a relative path working rather than throwing into the catch.
 */
export const dropAdsLandingEvent = (
  event: BeforeSendEvent
): BeforeSendEvent | null => {
  try {
    const { pathname } = new URL(event.url, window.location.href);
    const isAdsLandingPath = ADS_LANDING_PATHS.includes(
      pathname.replace(/\/+$/, '')
    );

    return isAdsLandingPath ? null : event;
  } catch {
    return event;
  }
};
